import { Dropdown, DropdownToggle } from 'react-bootstrap'
import { ThreeDotsHorizontalToggle } from './ThreeDotsToggle'
import { DropdownMenu } from './DropdownMenu'

/**
 * Convenience wrapper: a horizontal three-dots toggle button with a dropdown menu.
 * Just pass `AdvancedDropdownItem` (or any content) as children.
 */
export function ThreeDotsMenu({ children }: { children: React.ReactNode }) {
    return (
        <Dropdown>
            <DropdownToggle size='sm' as={ThreeDotsHorizontalToggle} />
            <DropdownMenu>
                {children}
            </DropdownMenu>
        </Dropdown>
    )
}
